import { useState, useEffect } from "react";
import "aos/dist/aos.css";
import "../../styles/modal.css";
import { FaCode, FaLaptopCode, FaDatabase, FaServer } from "react-icons/fa";
import { RiCalendarLine } from "react-icons/ri";

// Import images
import Img2 from "../../assets/images/atyp11-min.png";
// import Img41 from "../../assets/images/aideat3.PNG";
// import Img5 from "../../assets/images/jimmy.png";
// import Img7 from "../../assets/images/focusai.png";
// import Img6 from "../../assets/images/cabinet.png";
// import ImgWms from "../../assets/images/image1.png";
// import ImgGym from "../../assets/images/image2.png";
// import ImgLibrary from "../../assets/images/image33.jpg";
// import ImgChat from "../../assets/images/image444.jpg";
// import ImgNov from "../../assets/images/nova.png";
import Modal from "react-modal";

const Portfolio = () => {
  useEffect(() => {
    Modal.setAppElement("#root");
  }, []);

  const [selectedKeyword, setSelectedKeyword] = useState('all');

  const projects = [
    {
      id: 1,
      keywords: ["java", "ReactJS", "spring"],
      category: 'Enterprise Software',
      title: "Insurance Management Platform",
      description: "Developed a comprehensive insurance management platform covering contract simulation, customer tracking, and user management. Built a modern web interface with a secure backend, implementing automation of business processes and contributing to partner API integrations for seamless data exchange and simulation capabilities.",
      fullDescription: "Architected and developed a full-featured insurance management system with contract simulation tools, comprehensive customer relationship management, and robust user management capabilities. Implemented automated business workflows, secure data handling, and integrated multiple partner APIs for real-time data exchange. The platform enables insurance companies to streamline operations, manage policies efficiently, and enhance customer service through automated processes.",
      imageSrc: null,
      year: '2025-2026',
      technologies: ["Java 21", "Spring Boot", "ReactJS", "RESTful API", "Microservices", "PostgreSQL", "Docker"],
      highlights: ["Contract Simulation", "Customer Tracking", "API Integration", "Process Automation"],
      icon: <FaServer className="text-2xl" />
    },
    {
      id: 2,
      keywords: ["java", "ReactJS", "spring"],
      category: 'Enterprise Software',
      title: "Warehouse Management System",
      description: "Collaborated with an international development team to architect and implement a large-scale microservices-based warehouse management system. The platform optimizes supply chain operations, inventory tracking, and logistics coordination for enterprise clients.",
      fullDescription: "Designed and developed a comprehensive WMS using microservices architecture with Spring Boot and Java 21. Implemented CI/CD pipelines with Jenkins, code quality checks with SonarQube, and containerized deployment with Docker. The system handles millions of transactions daily and integrates with various ERP systems.",
      imageSrc: null, //ImgWms,
      year: '2024-2025',
      technologies: ["Spring Boot", "Java 21", "Microservices", "Jenkins", "SonarQube", "Docker", "ReactJS", "PostgreSQL"],
      highlights: ["Microservices Architecture", "CI/CD Pipeline", "High Scalability", "Enterprise Integration"],
      icon: <FaServer className="text-2xl" />
    },
    {
      id: 3,
      keywords: ["java", "ReactJS", "spring"],
      category: 'Business Management',
      title: "Gym Management Platform",
      description: "Created a comprehensive full-stack web application for gym and fitness center management. The platform streamlines membership operations, class scheduling, payment processing, and member engagement, providing an intuitive experience for both administrators and members.",
      fullDescription: "Developed a modern fitness management solution with real-time booking capabilities, automated billing, member analytics, and mobile-responsive design. Features include class management, trainer scheduling, payment gateway integration, and comprehensive reporting dashboards.",
      imageSrc: null, //ImgGym,
      year: '2023-2024',
      technologies: ["Spring Boot", "ReactJS", "PostgreSQL", "Tailwind CSS", "RESTful API", "JWT Authentication"],
      highlights: ["Real-time Booking", "Payment Integration", "Analytics Dashboard", "Mobile Responsive"],
      icon: <FaLaptopCode className="text-2xl" />
    },
    {
      id: 4,
      keywords: ['java', 'ReactJS'],
      category: 'Web Development',
      title: 'Digital Agency Platform',
      description: "Developed a modern, responsive web platform for a digital marketing agency. The platform showcases services, portfolio, client testimonials, and includes an integrated contact system with project inquiry forms.",
      fullDescription: "Created a professional agency website with dynamic content management, portfolio galleries, blog integration, and lead generation forms. Implemented SEO optimization, fast loading times, and mobile-first responsive design for optimal user experience across all devices.",
      imageSrc: null, //ImgNov,
      year: '2023',
      technologies: ["ReactJS", "Firebase", "Tailwind CSS", "HTML5", "CSS3", "JavaScript"],
      highlights: ["Responsive Design", "SEO Optimized", "Fast Performance", "Modern UI/UX"],
      icon: <FaCode className="text-2xl" />
    },
    {
      id: 5,
      keywords: ['java', 'ReactJS'],
      category: 'Business Management',
      title: 'Fitness Back-office Application',
      description: "Developed a robust administrative back-office application for a fitness website. Enables comprehensive management of membership packages, subscriptions, user accounts, content, and all site components through an intuitive admin interface.",
      fullDescription: "Built a powerful admin dashboard with user management, subscription handling, package configuration, content management, and analytics. Features include role-based access control, automated notifications, and comprehensive reporting tools for business insights.",
      imageSrc: null, //Img5,
      year: '2023',
      technologies: ["ReactJS", "Firebase", "Tailwind CSS", "HTML5", "JavaScript"],
      highlights: ["Admin Dashboard", "User Management", "Subscription Handling", "Analytics"],
      icon: <FaLaptopCode className="text-2xl" />
    },
    {
      id: 6,
      keywords: ['java', 'ReactJS'],
      category: 'Web Development',
      title: 'Web Agency Services Platform',
      description: "Engineered a professional platform for a web development agency to effectively showcase services, display portfolio projects, and streamline client communication. Features modern design and seamless user experience.",
      fullDescription: "Created a comprehensive agency website with service pages, project portfolio, client testimonials, team profiles, and integrated contact forms. Implemented modern design principles, fast performance, and mobile-responsive layout for optimal user engagement.",
      imageSrc: null, //Img7,
      year: '2023',
      technologies: ["Angular", "Firebase", "Tailwind CSS", "HTML5", "TypeScript"],
      highlights: ["Modern Design", "Portfolio Showcase", "Client Communication", "Performance Optimized"],
      icon: <FaCode className="text-2xl" />
    },
    {
      id: 7,
      keywords: ['java', 'ReactJS', 'spring'],
      category: 'E-Commerce & Booking',
      title: 'Accommodation Booking Platform',
      description: "Designed and implemented a user-friendly accommodation booking platform with advanced date selection, real-time availability checking, and secure payment processing. Integrated PayPal for seamless transactions and implemented comprehensive booking management features.",
      fullDescription: "Built a full-featured booking system with calendar-based availability, multi-property support, guest reviews, and automated confirmation emails. Implemented secure payment processing, cancellation policies, and comprehensive admin dashboard for property management.",
      imageSrc: Img2,
      year: '2021',
      technologies: ["Spring Boot", "ReactJS", "Java", "Spring Security", "Spring Data", "PostgreSQL", "JUnit", "Heroku", "JWT", "Redux"],
      highlights: ["Payment Integration", "Real-time Availability", "Secure Authentication", "Cloud Deployment"],
      icon: <FaCode className="text-2xl" />
    },
    {
      id: 8,
      keywords: ['java', 'spring'],
      category: 'Healthcare Management',
      title: 'Medical Office Management System',
      description: "Created a comprehensive platform to simplify medical office operations including patient record management, digital prescription generation, internal messaging system, and invoice management. Includes advanced reporting and printing capabilities.",
      fullDescription: "Developed a full-featured medical practice management system with patient scheduling, medical history tracking, prescription templates, billing management, and comprehensive reporting. Ensures HIPAA compliance and secure data handling for sensitive medical information.",
      imageSrc: null, //Img6,
      year: '2021-2022',
      technologies: ["Spring Boot", "Java", "JSP", "MySQL", "Bootstrap"],
      highlights: ["Patient Management", "Prescription System", "Billing Integration", "Secure Data Handling"],
      icon: <FaDatabase className="text-2xl" />
    },
    {
      id: 9,
      keywords: ['java', 'jee'],
      category: 'Research & Education',
      title: 'Laboratory Management System',
      description: "Built a specialized platform for research laboratories to streamline collaboration, manage research publications, filter articles by various criteria, and generate comprehensive annual reports. Includes advanced printing functionalities for documentation.",
      fullDescription: "Developed a comprehensive laboratory management solution with research article database, collaboration tools, citation management, and automated report generation. Features include advanced search filters, export capabilities, and integration with academic databases.",
      imageSrc: null, //ImgLibrary,
      year: '2019-2020',
      technologies: ["Java", "Jakarta EE (JEE)", "MySQL", "JSP", "MVC", "Bootstrap", "HTML5"],
      highlights: ["Research Database", "Report Generation", "Collaboration Tools", "Document Management"],
      icon: <FaDatabase className="text-2xl" />
    },
    // {
    //   id: 10,
    //   keywords: ['data science', 'ai'],
    //   category: 'AI & Machine Learning',
    //   title: 'AI Assistant Platform',
    //   description: "Developed an innovative AI-powered platform leveraging advanced Natural Language Processing (NLP) and Large Language Models (LLMs) to automate complex business workflows. The platform enables intelligent task automation, document processing, and contextual decision-making for enterprise clients.",
    //   fullDescription: "Built with cutting-edge AI technologies including GPT-4 and custom LLM integrations, this platform processes natural language queries, generates intelligent responses, and automates repetitive business tasks. Features include multi-tenant architecture, real-time processing, and comprehensive analytics dashboard.",
    //   imageSrc: null, //Img41,
    //   year: '2023',
    //   technologies: ["Django", "Python", "LLMs", "PostgreSQL", "Redis", "ReactJS", "AWS EC2", "AWS S3", "Docker"],
    //   highlights: ["NLP Integration", "Multi-tenant Architecture", "Real-time Processing", "Cloud Deployment"],
    //   icon: <FaRobot className="text-2xl" />
    // },
    // {
    //   id: 11,
    //   keywords: ['data science', 'ai'],
    //   category: 'AI & Machine Learning',
    //   title: 'Intelligent Chatbot Development',
    //   description: 'Built multiple production-ready chatbots using state-of-the-art AI technologies including HuggingFace transformers, GPT-4, and Llama 2. Implemented advanced PDF processing, context-aware responses, and seamless integration with various platforms.',
    //   fullDescription: "Developed enterprise-grade chatbots with advanced capabilities including document understanding, multi-turn conversations, and custom knowledge base integration. Utilized LangChain for orchestration and Flowise for workflow management, enabling businesses to automate customer support and internal processes.",
    //   imageSrc: null, //ImgChat,
    //   year: '2023',
    //   technologies: ["Llama 2", "GPT-4", "HuggingFace", "LangChain", "Flowise", "Python", "FastAPI"],
    //   highlights: ["Document Processing", "Context Awareness", "Multi-platform Integration", "Custom Training"],
    //   icon: <FaRobot className="text-2xl" />
    // },
  ];

  const categories = [
    { id: 'all', label: 'All Projects', count: projects.length, icon: <FaCode /> },
    { id: 'java', label: 'Web Development', count: projects.filter(p => p.keywords.includes('java')).length, icon: <FaLaptopCode /> },
    // { id: 'data science', label: 'AI & ML', count: projects.filter(p => p.keywords.includes('data science')).length, icon: <FaRobot /> },
  ];

  const filteredProjects = selectedKeyword === 'all'
    ? projects
    : projects.filter(project => project.keywords.includes(selectedKeyword));

  const getCategoryColor = (category) => {
    const colors = {
      'AI & Machine Learning': 'bg-purple-100 dark:bg-purple-900/30 text-purple-800 dark:text-purple-300',
      'Enterprise Software': 'bg-blue-100 dark:bg-blue-900/30 text-blue-800 dark:text-blue-300',
      'Business Management': 'bg-green-100 dark:bg-green-900/30 text-green-800 dark:text-green-300',
      'E-Commerce & Booking': 'bg-orange-100 dark:bg-orange-900/30 text-orange-800 dark:text-orange-300',
      'Web Development': 'bg-indigo-100 dark:bg-indigo-900/30 text-indigo-800 dark:text-indigo-300',
      'Research & Education': 'bg-teal-100 dark:bg-teal-900/30 text-teal-800 dark:text-teal-300',
      'Healthcare Management': 'bg-red-100 dark:bg-red-900/30 text-red-800 dark:text-red-300',
    };
    return colors[category] || 'bg-gray-100 dark:bg-gray-700 text-gray-800 dark:text-gray-300';
  };

  return (
    <section
      id="portfolio"
      className="bg-white dark:bg-gray-600 pt-16 pb-20 transition-colors duration-300"
    // data-aos="fade-up"
    >
      <div className="experience-card bg-white dark:bg-gray-700 
        sm:m-4 md:m-14 lg:m-14 border-2 border-primaryColor dark:border-primaryColorDark
        shadow-lg dark:shadow-2xl transition-colors duration-300 rounded-lg">

        <div className="container mx-auto px-4 pt-8 pb-6">
          {/* Header Section */}
          <div className="text-center mb-12">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-800 dark:text-primaryColorDark mb-4 transition-colors duration-300">
              <span className="border-b-4 border-primaryColor dark:border-primaryColorDark pb-2 transition-colors duration-300 inline-block">
                Featured Projects
              </span>
            </h1>
            <p className="lg:max-w-3xl lg:mx-auto text-gray-600 dark:text-gray-300 text-lg md:text-xl leading-relaxed pt-4 transition-colors duration-300">
              Explore a curated collection of my work spanning web development, AI solutions, and enterprise software.
              Each project represents innovative solutions to real-world challenges.
            </p>
          </div>

          {/* Filter Buttons */}
          <div className="flex flex-wrap justify-center gap-4 mb-12">
            {categories.map((category) => (
              <button
                key={category.id}
                onClick={() => setSelectedKeyword(category.id)}
                className={`group flex items-center gap-2 px-6 py-3 rounded-lg font-semibold transition-all duration-300 ${selectedKeyword === category.id
                  ? 'bg-primaryColor dark:bg-primaryColorDark text-white shadow-lg scale-105'
                  : 'bg-gray-100 dark:bg-gray-600 text-gray-700 dark:text-gray-300 hover:bg-primaryColor dark:hover:bg-primaryColorDark hover:text-white hover:scale-105'
                  }`}
              >
                <span className={`${selectedKeyword === category.id ? 'text-white' : ''}`}>
                  {category.icon}
                </span>
                <span>{category.label}</span>
                <span className={`px-2 py-0.5 rounded-full text-xs ${selectedKeyword === category.id
                  ? 'bg-white/20 text-white'
                  : 'bg-gray-200 dark:bg-gray-500 text-gray-700 dark:text-gray-300'
                  }`}>
                  {category.count}
                </span>
              </button>
            ))}
          </div>

          {/* Projects Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
            {filteredProjects.map((project, index) => (
              <div
                key={project.id}
                // data-aos="fade-up"
                // data-aos-delay={index * 100}
                className="group bg-white dark:bg-gray-600 rounded-xl border-2 border-gray-200 dark:border-gray-500 
                         hover:border-primaryColor dark:hover:border-primaryColorDark
                         overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 
                         transform hover:-translate-y-2 flex flex-col"
              >
                {/* Image Container */}
                {project.imageSrc ? (
                  <div className="relative overflow-hidden bg-gray-100 dark:bg-gray-700">
                    <img
                      className="w-full h-48 object-cover transition-transform duration-500 group-hover:scale-110"
                      src={project.imageSrc}
                      alt={project.title}
                    />
                    <div className="absolute top-3 right-3">
                      <span className={`px-3 py-1 rounded-full text-xs font-semibold ${getCategoryColor(project.category)}`}>
                        {project.category}
                      </span>
                    </div>
                    <div className="absolute top-3 left-3 flex items-center gap-1 bg-black/50 text-white px-2 py-1 rounded-md text-sm">
                      <RiCalendarLine />
                      <span>{project.year}</span>
                    </div>
                  </div>
                ) : (
                  <div className="relative overflow-hidden bg-gradient-to-br from-primaryColor/20 to-blue-600/20 dark:from-primaryColorDark/20 dark:to-blue-500/20 h-48 flex items-center justify-center">
                    <div className="text-primaryColor dark:text-primaryColorDark text-6xl">
                      {project.icon}
                    </div>
                    <div className="absolute top-3 right-3">
                      <span className={`px-3 py-1 rounded-full text-xs font-semibold ${getCategoryColor(project.category)}`}>
                        {project.category}
                      </span>
                    </div>
                    <div className="absolute top-3 left-3 flex items-center gap-1 bg-black/50 text-white px-2 py-1 rounded-md text-sm">
                      <RiCalendarLine />
                      <span>{project.year}</span>
                    </div>
                  </div>
                )}

                {/* Content */}
                <div className="p-6 flex-grow flex flex-col">
                  {/* Title and Icon */}
                  <div className="flex items-start gap-3 mb-3">
                    <div className="text-primaryColor dark:text-primaryColorDark mt-1">
                      {project.icon}
                    </div>
                    <h3 className="text-xl font-bold text-gray-800 dark:text-white group-hover:text-primaryColor dark:group-hover:text-primaryColorDark transition-colors duration-300">
                      {project.title}
                    </h3>
                  </div>

                  {/* Description */}
                  <p className="text-gray-600 dark:text-gray-300 text-sm leading-relaxed mb-4 flex-grow">
                    {project.description}
                  </p>

                  {/* Highlights */}
                  {project.highlights && project.highlights.length > 0 && (
                    <div className="flex flex-wrap gap-2 mb-4">
                      {project.highlights.slice(0, 2).map((highlight, idx) => (
                        <span
                          key={idx}
                          className="px-2 py-1 bg-primaryColor/10 dark:bg-primaryColorDark/20 text-primaryColor dark:text-primaryColorDark 
                                   text-xs font-medium rounded-md"
                        >
                          {highlight}
                        </span>
                      ))}
                    </div>
                  )}

                  {/* Technologies */}
                  <div className="mt-auto pt-4 border-t border-gray-200 dark:border-gray-500">
                    <p className="text-xs font-semibold text-gray-500 dark:text-gray-400 mb-2">
                      Technologies:
                    </p>
                    <div className="flex flex-wrap gap-1.5">
                      {project.technologies.slice(0, 4).map((tech, idx) => (
                        <span
                          key={idx}
                          className="px-2 py-1 bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 
                                   text-xs rounded-md font-medium"
                        >
                          {tech}
                        </span>
                      ))}
                      {project.technologies.length > 4 && (
                        <span className="px-2 py-1 bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 
                                       text-xs rounded-md font-medium">
                          +{project.technologies.length - 4}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Empty State */}
          {filteredProjects.length === 0 && (
            <div className="text-center py-12">
              <FaCode className="text-6xl text-gray-300 dark:text-gray-600 mx-auto mb-4" />
              <p className="text-gray-500 dark:text-gray-400 text-lg">
                No projects found in this category.
              </p>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default Portfolio;
